import React, { useCallback } from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import { Url } from '@wix/da-url';
import ArtStageArrowR from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import { useSelector } from 'react-redux';
import { getStashFolder, getStashNext, getStashPrev } from '../../../DeviationPage/redux/selectors';
import { getStashBiEventData } from '../../../Duperbrowse/redux/helpers';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
import BackToStashButton from '../BackToStashButton';
import StashPaddle from './StashPaddle';
import s from './StashPaddles.scss';
const StashPaddles = ({ className, paddleClassName, iconClassName })=>{
    const next = useSelector(getStashNext);
    const prev = useSelector(getStashPrev);
    const folder = useSelector(getStashFolder);
    const currentItem = useSelector(getCurrentItem);
    const openPrev = useCallback(()=>{
        window.location.assign(Url.stashItemLink(prev !== null && prev !== void 0 ? prev : ''));
    }, [
        prev
    ]);
    const openNext = useCallback(()=>{
        window.location.assign(Url.stashItemLink(next !== null && next !== void 0 ? next : ''));
    }, [
        next
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(StashPaddle, {
        disabled: !prev,
        className: classnames(s['prev'], paddleClassName),
        onClick: openPrev,
        dataHook: "arrowL",
        biData: currentItem && getStashBiEventData(currentItem, 'prev')
    }, /*#__PURE__*/ React.createElement(ArtStageArrowL, {
        customSizable: true,
        disableDefaultColors: true,
        className: classnames(s['icon'], iconClassName)
    })), folder && /*#__PURE__*/ React.createElement(BackToStashButton, null), /*#__PURE__*/ React.createElement(StashPaddle, {
        disabled: !next,
        className: classnames(s['next'], paddleClassName),
        onClick: openNext,
        dataHook: "arrowR",
        biData: currentItem && getStashBiEventData(currentItem, 'next')
    }, /*#__PURE__*/ React.createElement(ArtStageArrowR, {
        customSizable: true,
        disableDefaultColors: true,
        className: classnames(s['icon'], iconClassName)
    })));
};
StashPaddles.displayName = 'StashPaddles';
export default StashPaddles;

//# sourceMappingURL=StashPaddles.js.map